import { OPEN_DOCUMENT_STORAGE_KEY } from '../constants/openDocumentStorageKey'

export const setPendingOpenDocumentId = (documentId: string): void => {
  sessionStorage.setItem(OPEN_DOCUMENT_STORAGE_KEY, documentId)
}

export const consumePendingOpenDocumentId = (): string | null => {
  const documentId = sessionStorage.getItem(OPEN_DOCUMENT_STORAGE_KEY)
  if (documentId) {
    sessionStorage.removeItem(OPEN_DOCUMENT_STORAGE_KEY)
  }
  return documentId
}
